<template>
  <div class="advantage-container flex-box">
    <img v-lazy="bj2" alt="" class="advantage-bj">
    <div class="title">璞华易研PLM的优势</div>
    <div class="description">璞华易研PLM始终根植于用户需求，不断快速迭代升级</div>
    <div class="advantage-list flex-box">
      <div class="list-item" v-for="(item, k) in topList" :key="k">
        <div class="item-num">{{ item.num }}</div>
        <div class="item-title">{{ item.title }}</div>
        <div class="item-description">{{ item.description }}</div>
        <div class="item-backg"></div>
      </div>
    </div>
    <div class="advantage-list flex-box">
      <div class="list-item list-item2" v-for="(item, k) in bottomList" :key="k">
        <div class="item-num">{{ item.num }}</div>
        <div class="item-title">{{ item.title }}</div>
        <div class="item-description">{{ item.description }}</div>
        <div class="item-backg"></div>
      </div>
    </div>
  </div>
</template>

<script>
import bj2 from '@/assets/images/bj2.png'
export default {
  data() {
    return {
      bj2,
      topList: [
        {
          num: '01',
          title: '国产自主，易于集成',
          description: '底层代码均为自主研发，无需购买其他插件； 与设计工具及其他业务系统均有标准接口，且支持特性需求扩展'
        },
        {
          num: '02',
          title: '先进的云原生BS架构',
          description: '易部署、易扩展、微服务、容器化'
        },
        {
          num: '03',
          title: '极简的交互体验',
          description: '以用户易操作为设计导向，降低系统学习成本，提高用户&系统黏性'
        }
      ],
      bottomList: [
        {
          num: '04',
          title: '基于低代码平台开发，满足企业不同的业务要求',
          description: '璞华易研PLM系统设计采用面向对象建模的思想，用户可以根据自己的业务自行搭建部分业务，同时提供丰富扩展接口，满足特定场景'
        },
        {
          num: '05',
          title: '专注于行业，提供最佳业务实践',
          description: '专注于特定行业提供业务梳理、流程落地、系统实现，积累了大量行业经验，保证业务流程与系统的完美结合'
        }
      ],
      activeIndex: 0
    }
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.advantage-container {
  padding: 9rem 26rem 7.5rem;
  flex-direction: column;
  align-items: center;
  position: relative;

  .advantage-bj {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 7.2rem;
  }

  .advantage-list {
    width: 100%;
    flex: 1;
    justify-content: space-between;
    margin-bottom: 4rem;

    .list-item {
      width: 44rem;
      height: 18rem;
      background: #FFFFFF;
      box-shadow: 0rem 0.5rem 4rem 0rem rgba(196,211,228,0.3);
      padding: 3.6rem 4rem 0;
      cursor: pointer;
      position: relative;
      .item-num {
        position: absolute;
        height: 5.6rem;
        font-size: 4.8rem;
        font-weight: bold;
        color: #3674FE;
        line-height: 5.6rem;
        left: 4rem;
        top: 1rem;
        opacity: .1;
      }
      .item-title {
        height: 2.4rem;
        font-size: 2.4rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 2.4rem;
        margin-bottom: 2rem;
      }
      .item-description {
        height: 4.8rem;
        font-size: 1.6rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 2.4rem;
      }
      .item-backg {
        position: absolute;
        width: 14rem;
        height: 11rem;
        right: 0;
        bottom: 0;
      }
      &:hover {
        background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
        .item-num {
          color: #FFFFFF;
        }
        .item-title {
          color: #FFFFFF;
        }
        .item-description {
          color: #FFFFFF;
        }
        .item-backg {
          background: url('#{$img}/bj3.png');
          background-size: 100% 100%;
        }
      }
    }

    .list-item2 {
      width: 68rem;
      padding: 4.2rem 4rem 0;
      .item-title {
        margin-bottom: 2.4rem;
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .advantage-container {
    padding: 4.8rem 1.6rem;

    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      margin-bottom: 3.2rem;
      text-align: center;
    }
    .advantage-list {
      flex-wrap: wrap;
      .list-item,
      .list-item2 {
        width: 100%;
        height: auto;
        margin-bottom: 1.6rem;
        padding: 2.4rem 1.6rem 4rem;
        overflow: visible;
        .item-title,
        .item-description {
          height: auto;
          white-space: normal;
          word-break: break-word;
        }
      }
    }
  }
}
</style>
